import React from "react";

interface AboutImageSectionProps {
  className?: string;
  image: string;
}

const AboutImageSection: React.FC<AboutImageSectionProps> = ({ className = "", image }) => {
  return (
    <section className={`relative container  py-16 ${className}`}>
      <div className="bg-slate-200 mx-auto rounded-3xl">
        <div className="flex flex-col md:flex-row items-center gap-12">
          {/* Image */}
          <div className="w-full md:w-1/2">
            <img src={image} alt="Office" className="w-full h-full object-cover rounded-3xl mt-0 ml-0 mb-0 md:-mt-4 md:-ml-4 md:-mb-4" />
          </div>

          {/* Content */}
          <div className="w-full md:w-1/2 px-10 pb-10">
            <h2 className="text-4xl font-semibold mb-6">We believe in putting you first. Our unique approach to customer relationships sets us apart in the digital payment world.</h2>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutImageSection;
